export const sideScroll = (element:HTMLElement,options:Record<string,string | number>) =>{
    let scrollAmount = 0;
    var slideTimer = setInterval(function(){
        let step = options.step as number;
        let distance = options.distance as number;
        if(options.direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, options.speed as number);
}